import setMomentDateObjZero from './setMomentDateObjZero.js'


const getPeriodeEndDate = (startMomentDate, daysPerPeriode = 9) => {
    const momentDateZero  = setMomentDateObjZero(startMomentDate.clone())
    
    return momentDateZero.add(daysPerPeriode,'days')
} 

export default getPeriodeEndDate